<template>
  <div>
    <guide-table
      :guide-code="guideCode"
      class="mb-1"
      @select="onGuideTableSelect"
      v-show="!guideSelected"
    />
    <div v-show="guideSelected">
      <b-button
        icon-left="list"
        @click.prevent="guideSelected = null"
        style="margin-bottom: 5px;"
      >
        Guides
      </b-button>
      <b-button
        @click.prevent="runGuideJob"
        style="margin-bottom: 5px;"
      >
        Run Job
      </b-button>
      <guide-slider
        :guide="guideSelected"
        :fetch-on-init="false"
        @fetch="onGuideSliderFetch"
        ref="guideSlider"
      />
    </div>
  </div>
</template>

<script>
import GuideTable from "@/components/Guide/GuideTable";
import GuideSlider from "@/components/Guide/GuideSlider";

export default {
  components: {
    GuideTable,
    GuideSlider
  },
  props: {
    guideCode: {
      type: String
    }
  },
  data: () => ({
    guideSelected: null
  }),
  watch: {
    guideSelected() {
      this.$nextTick(() => {
        if (this.guideSelected) {
          this.$refs.guideSlider.fetchSteps();
        } else {
          this.$refs.guideSlider.clearSteps();
        }
      });
    }
  },
  methods: {
    onGuideTableSelect(guide) {
      this.guideSelected = guide;
    },
    onGuideSliderFetch() {
      this.$emit("slider-fetch");
    },
    async runGuideJob() {
      if (
        this.guideSelected &&
        this.guideSelected.testResult &&
        this.guideSelected.testResult.attributes.job_id
      ) {
        await fetch(
          `https://api.uilicious.com/v3.0/project/job/${this.guideSelected.testResult.attributes.job_id}/run?accessKey=${process.env.UILICIOUS_KEY}`,
          {
            method: "POST"
          }
        );
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Guide/Guides.vue